export const FOOTER_ITEMS = [
  {
    heading: 'Company',
    items: [
      { name: 'About Us', link: '/about' },
      { name: 'Contact Us', link: '/contact' },
      { name: 'Privacy Policy', link: '/privacy-policy' },
    ],
  },
  {
    heading: 'Services',
    items: [
      { name: 'SAT', link: '/sat' },
      { name: 'APs', link: '/aps' },
      { name: 'Ivy League Program', link: '/ivy-league' },
      { name: 'Job Mapping', link: '/job-mapping' },
    ],
  },
  {
    heading: 'Resources',
    items: [
      { name: 'Pariksha - Assessments', link: '/pariksha' },
      { name: 'Career Navigation', link: '/career-navigation' },
      { name: 'Internships', link: '/consulting/internships' },
      { name: 'Testimonials', link: '/testimonials' },
    ],
  },
];
//footer section 